import React, { useState } from "react";
import { Button, Toast } from "..";
import { useOrderContext, useAppContext } from "../../contexts";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import {
  updateExchangeSettingsDetails,
  updateRefundSettingsDetails,
  setProductDetails,
} from "../../redux/slices";
import {
  exchangeSettingsActionTypes,
  refundSettingsActionTypes,
  productActionTypes,
} from "../../redux/utils";
import { getUpdatedOrderInfo } from "../../Utilities";
import { useAPI } from "../../hooks";
export const GetRefund = () => {
  const { setIsSelected } = useOrderContext();
  const [refundReturnID, setRefundReturnID] = useState();
  const [isLoader, setIsLoader] = useState(false);
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const { isInternalServerError, setIsInternalServerError } = useAppContext();
  const { setRecentOrderID, setVariantID } = useOrderContext();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const productDetailsState = useSelector((state) => state.productDetails);
  const exchangeSettingsState = useSelector((state) => state.exchangeSettings);
  const refundSettingsState = useSelector((state) => state.refundSettings);
  const storeConfigState = useSelector((state) => state.storeSettings);

  const selectedProductDetailsState = useSelector(
    (state) => state.selectedProductDetails
  );

  const { ACCEPT_INCENTIVE_API } = useAPI();

  /* Refund and Return Options */
  const RefundReturnOption = [
    {
      /*First option is disabled */
      id: "1",
      name: storeConfigState?.themeConfig
        ?.return_option_page_incentive_card_title,
      desc: storeConfigState?.themeConfig
        ?.return_option_page_incentive_card_content,
      isEnable: false,
      isShow: false,
    },
    {
      id: "2",
      name: storeConfigState?.themeConfig
        ?.return_option_page_incentive_card_title,
      desc: storeConfigState?.themeConfig
        ?.return_option_page_incentive_card_content
        ? storeConfigState?.themeConfig
            ?.return_option_page_incentive_card_content
        : `${productDetailsState.currency}${refundSettingsState.incentive.keep_item_store_credits.refund_value} ${storeConfigState?.themeConfig?.incentive_accept_right_card_title}`,
      isEnable:
        productDetailsState.enableIncentive ||
        productDetailsState.isPolicyOverwritten,
      isShow:
        refundSettingsState.incentive.keep_item_store_credits.refund_value >
          0 && productDetailsState.enableIncentive,
    },
    {
      id: "3",
      name: storeConfigState?.themeConfig?.return_option_page_refund_card_title,
      desc: storeConfigState?.themeConfig
        ?.return_option_page_refund_card_content,
      isEnable:
        exchangeSettingsState.isEnableRefund ||
        productDetailsState.isPolicyOverwritten,
      isShow: productDetailsState.isShowRefund,
    },
  ];

  const buttonHandler = () => {
    (async () => {
      setIsLoader(true);
      setIsBtnDisabled(true);

      const RecentOrderID = productDetailsState.recentOrderID;
      const VariantID = selectedProductDetailsState.variantID;
      const productID = selectedProductDetailsState.productID;
      setRecentOrderID(RecentOrderID);
      setVariantID(VariantID);
      if (refundReturnID === "2") {
        try {
          const response = await fetch(ACCEPT_INCENTIVE_API, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              order_id: RecentOrderID,
              shop: storeConfigState.storeUniqueID,
              variant_id: VariantID,
              test_mode: productDetailsState.testMode,
              line_item_id: selectedProductDetailsState.lineItemID,
              quantity: parseInt(selectedProductDetailsState.selectedQuantity),
              incentive: refundSettingsState.incentive,
            }),
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();

          if (response.ok) {
            navigate("/ThankYou");
            setIsLoader(false);
            dispatch(
              updateRefundSettingsDetails({
                key: refundSettingsActionTypes.UPDATE_THANKYOU_HEADING,
                value:
                  storeConfigState?.themeConfig?.incentive_accept_left_title,
              })
            );

            dispatch(
              updateRefundSettingsDetails({
                key: refundSettingsActionTypes.UPDATE_THANKYOU_DESCRIPTION,
                value:
                  storeConfigState?.themeConfig?.incentive_accept_left_content,
              })
            );

            dispatch(
              updateRefundSettingsDetails({
                key: refundSettingsActionTypes.UPDATE_THANKYOU_CARD_HEADING,
                value:
                  storeConfigState?.themeConfig
                    ?.incentive_accept_right_card_title,
              })
            );

            dispatch(
              updateRefundSettingsDetails({
                key: refundSettingsActionTypes.UPDATE_KEEP_THE_ITEM_AMOUNT_DESCRIPTION,
                value:
                  storeConfigState?.themeConfig
                    ?.incentive_accept_right_card_subtitle,
              })
            );
            dispatch(
              updateRefundSettingsDetails({
                key: refundSettingsActionTypes.UPDATE_REFUND_REVIEW_ROUTE,
                value: "KEEP_THE_ITEM_SHOP_LATER",
              })
            );
            dispatch(
              updateRefundSettingsDetails({
                key: refundSettingsActionTypes.UPDATE_REFUND_METHOD,
                value:
                  refundSettingsState?.incentive?.keep_item_store_credits
                    ?.label,
              })
            );
            dispatch(
              updateRefundSettingsDetails({
                key: refundSettingsActionTypes.UPDATE_TOTAL_REFUND,
                value:
                  refundSettingsState?.incentive?.keep_item_store_credits
                    ?.refund_value,
              })
            );
            // Get updated product details
            const updatedOrderInfo = getUpdatedOrderInfo(
              productDetailsState,
              selectedProductDetailsState
            );

            // Update the product list on Redux
            dispatch(
              setProductDetails({
                key: productActionTypes.SET_ORDER_INFO,
                value: updatedOrderInfo,
              })
            );

            setIsBtnDisabled(false);
          }
        } catch (error) {
          if (error.message.includes('500')) {
            setIsInternalServerError(true);
          }
          setIsBtnDisabled(false);
        }
      } else if (refundReturnID === "3") {
        navigate("/RefundOptions");
        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NAVIGATE_BACK,
            value: "/refund",
          })
        );
      }
    })();
  };

  /*Navigate to Previous Page */
  const backHandler = () => {
    window.history.back();
  };

  return (
    <div className="p12 choose">
      {isInternalServerError && <Toast type="error" />}
      <div className="saara__container">
        <div className="saara-justify-content-center row__title">
          <Link to="" onClick={backHandler} className="btn__small_screen">
            <img src="assets/svg/chevron_left.svg" alt="back" />
          </Link>
          <div>
            <h1 className="p12__title saara-title">
              {storeConfigState?.themeConfig?.return_option_page_title}
            </h1>
          </div>
        </div>
        <div className=" saara-justify-content-center p12__row">
          {RefundReturnOption.map((item) => {
            return (
              <div
                className={` ${
                  !item.isShow && "saara-d-none"
                }  choose__card saara-cursor-pointer ${
                  refundReturnID === item.id && item.isEnable ? "active" : ""
                } `}
                key={item.id}
                onClick={() => {
                  setRefundReturnID(item.id);
                  setIsSelected(true);
                  setIsBtnDisabled(!item.isEnable ? true : false);
                }}
              >
                <div className="choose__card_text  saara-justify-content-center">
                  <h2 className="choose__card_title">{item.name}</h2>

                  <p className="choose__text ">
                    <span className="item__desc">{item.desc}</span>
                  </p>
                  {!item.isEnable && (
                    <span className="  saara-justify-content-center info__error ">
                      {storeConfigState.returnPolicyURL ? (
                        <a
                          className="info__error_policy"
                          href={
                            storeConfigState?.themeConfig?.return_policy_url
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          {
                            storeConfigState?.themeConfig
                              ?.errors_option_not_applicable
                          }
                        </a>
                      ) : (
                        storeConfigState?.themeConfig
                          ?.errors_option_not_applicable
                      )}
                    </span>
                  )}
                </div>
                <label className="p12__label">
                  <input className="choose__input" type="radio" name="choose" />
                  <span className="choose__input_circle big "></span>
                </label>
              </div>
            );
          })}
        </div>
        <div className=" btns">
          <div className=" btn__big_screen margin-right-20">
            <button
              className="saara_custom_btn saara__btn btn__back back_page"
              onClick={backHandler}
            >
              {storeConfigState?.themeConfig?.back_button_label}
            </button>
          </div>

          <div>
            <Button
              name={
                isLoader ? (
                  <div
                    className="saara-spinner-border saara-spinner-border-sm"
                    role="status"
                  >
                    <span className="saara-visually-hidden"></span>
                  </div>
                ) : (
                  storeConfigState?.themeConfig?.continue_button_label
                )
              }
              onClick={buttonHandler}
              disabled={isBtnDisabled}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
